//JavaScript Document
import "@babel/polyfill";
import Vue from "vue";

import "@dss/js/module";
import component from "@dss/js/component";
import mixin from "@dss/js/service/mixin";
import i18n from "@dss/js/i18n";

Vue.use(component);

Vue.mixin(mixin);

import iView from "view-design";

import "view-design/dist/styles/iview.css";

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value),
});

import globals from "@/utils/global";

Vue.use(globals);

Vue.prototype.$Message.config({
  duration: 5,
});

import App from "@/container/app";

import router from "@/router";

import store from "@/store";
function getQueryParam(name) {
  const regex = new RegExp('[?&]' + name + '=([^&#]*)');
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
try {
  if (getQueryParam('hdpagetype') === 'HAIER_DATA') {
    new Vue({
      render: (h) => h(App),
      router,
      store,
      i18n,
    }).$mount("#app");
  } else {
    location.href = './404.html'
  }
} catch (e) {
  console.log(e)
}
